export default __webpack_public_path__ + "static/media/closet5-before1-1920w.6e7378d7.webp";